import { render } from "./DefaultNavigation.vue?vue&type=template&id=d995aed0"
import script from "./DefaultNavigation.vue?vue&type=script&lang=js"
export * from "./DefaultNavigation.vue?vue&type=script&lang=js"

import "./DefaultNavigation.vue?vue&type=style&index=0&id=d995aed0&lang=scss"
import "./DefaultNavigation.vue?vue&type=style&index=1&id=d995aed0&lang=scss"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__